module.exports = __webpack_public_path__ + "img/Icon_nav_calendar.39fc5acb.svg";